//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

import { OnboardingAnalyticsCard } from '@welcome-page/components/onboarding/steps/OnboardingAnalyticsCard';
import { OnboardingCatalogCard } from '@welcome-page/components/onboarding/steps/OnboardingCatalogCard';
import { OnboardingSocialCard } from '@welcome-page/components/onboarding/steps/OnboardingSocialCard';
import { OnboardingStepStatus } from '@welcome-page/constants/OnboardingConstants';

export interface OnboardingState {
  isError: boolean;
  status: OnboardingStepStatus;
}

interface Props {
  analyticsOnboardingState: OnboardingState;
  catalogOnboardingState: OnboardingState;
  socialOnboardingState: OnboardingState;
}

export const OnboardingCardGrid = ({
  analyticsOnboardingState,
  catalogOnboardingState,
  socialOnboardingState,
}: Props) => {
  return (
    <CardGridContainer>
      <OnboardingSocialCard
        isError={socialOnboardingState.isError}
        status={socialOnboardingState.status}
      />
      <OnboardingAnalyticsCard
        isError={analyticsOnboardingState.isError}
        status={analyticsOnboardingState.status}
      />
      <OnboardingCatalogCard
        isError={catalogOnboardingState.isError}
        status={catalogOnboardingState.status}
      />
    </CardGridContainer>
  );
};

const CardGridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 40px;
  height: 234px;
`;
